<template>
  <div v-if="deviceDid">
    <el-tabs v-model="activename">
      <el-tab-pane :label="$t('lang.ConfigSetting.DomainFilter')" name="DomainFiltering">
        <domain-filtering 
          :deviceDid="deviceDid"
          :deviceSn="deviceSn"
          :data="data">
        </domain-filtering>
      </el-tab-pane>
      <el-tab-pane  :label="$t('lang.ConfigSetting.KeywordFilter')" name="KeywordFiltering">
        <keyword-filtering
          :deviceDid="deviceDid"
          :deviceSn="deviceSn"
          :data="data">
        </keyword-filtering>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DomainFiltering from './components/DomainFiltering/index'
import KeywordFiltering from './components/KeywordFiltering/index'
export default {
  props:["deviceDid", "deviceSn", 'data'],
  components: {
    DomainFiltering,
    KeywordFiltering,
  },
  data() {
    return {
      activename: 'DomainFiltering'
    }
  },
  created() {
  }
}
</script>